<template>
  <div class="game">

    <game-intro v-if="setupGame.gameView == 1"></game-intro>
    <game-rules v-if="setupGame.gameView == 2"></game-rules>
    <game-lvl v-if="setupGame.gameView == 3"  @limit="limit = $event"></game-lvl>

    <game-order v-if="showGameAccess" :orderType="2"></game-order>
    <game-map v-if="showGameMap" :stepOrder="'game_two'"></game-map>


    <mission-name v-if="setupGame.gameView != 1" v-bind:memoryGame="memoryGame" :mission-name="memoryGame.missionName" :mission-title="memoryGame.gameName"></mission-name>
    <div class="game-store" v-if="setupGame.gameView == 4 & !showGameAccess & !showGameMap">

      <game-timer v-if="setupGame.gameLevel === 'easy'" :timeLimit="120"  @gameOver="gameOver = $event" @showMessage="showMessage = $event"></game-timer>
      <game-timer v-if="setupGame.gameLevel === 'hard'" :timeLimit="50"  @gameOver="gameOver = $event" @showMessage="showMessage = $event"></game-timer>

      <div class="end-game-mask" v-if="gameOver">
        <div class="wrap-end-game">
          <div class="spider"></div>
          <div class="benia">
            <div class="message-box left message-300">
              <div class="top"></div>
              <div class="wrap left">
                <h3>
                  Koniec gry.<br />
                  Spróbuj jeszcze raz.
                </h3>
              </div>
              <div class="bottom"></div>
            </div>
          </div>
          <div class="action-bar">
            <button class="btn btn-green-light" @click="resetGame(3)"><span>Spróbuj jeszcze raz</span></button>
          </div>
        </div>
      </div>

      <hero v-if="setupGame.gameView == 4">Brawo!</hero>
      <div class="col memory">
        <div class="col-claim memory-card-list">
          <div class="cards">
            <div v-for="card in memoryCards" class="flip-container" :class="{ 'flipped': card.isFlipped, 'matched' : card.isMatched }" @click="flipCard(card)">
              <div class="memorycard">
                <div class="front border rounded shadow"><img src="@/assets/images/memorycard/pattern.png"></div>
                <div class="back rounded border">
                  <img :src="require(`@/assets/images/memorycard/${card.img}`)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hero-duck class="hide-mob"></hero-duck>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import {mapActions, mapGetters,mapMutations} from "vuex";
import GameIntro from '@/organism/OrganismGameIntro.vue';
import GameLvl from '@/organism/OrganismSelectLevel.vue';
import GameRules from '@/organism/OrganismGameRules';
import GameOrder from "@/organism/OrganismGameGetOrder";
import GameMap from "@/organism/OrganismGameMap";
import MissionName from '@/components/missionName';
import GameTimer from '@/components/gameTimer';
import hero from '@/molecules/MoleculeHeroAvatar';
import heroDuck from '@/molecules/MoleculeHeroDuck';

export default {
name: "GameTwo",
  data () {
    return {
      gameOver : false,
      gameLevel:  null,
      showGameAccess: false,
      showGameMap:false,
      cards: null,
      isFlipped: false,
      finish: false,
      memoryCards: [],
      flippedCards: [],
      missionName:null,
    }
  },
  components: {
    GameIntro,
    GameLvl,
    GameRules,
    GameOrder,
    GameMap,
    MissionName,
    heroDuck,
    hero,
    GameTimer
  },
  computed: {
    ...mapGetters(['setupGame','memoryGame']),

  },
  created(){
    this.cards = this.memoryGame.dataSetCard
    this.cards.forEach((card) => {
      Vue.set(card,'isFlipped',false);
      Vue.set(card,'isMatched',false);
    });
    this.memoryCards = _.shuffle(this.memoryCards.concat(_.cloneDeep(this.cards), _.cloneDeep(this.cards)));

  },

  methods:{
    ...mapActions([ 'startGame','audioPlayer','stopAudio']),
    ...mapMutations(['SET_ACTIVE_GAME','SET_ACTIVE_VIEW']),

    flipCard(card){
      if(card.isMatched || card.isFlipped || this.flippedCards.length === 2)
        return;
      card.isFlipped = true;
      if(this.flippedCards.length < 2)
        this.flippedCards.push(card);
      if(this.flippedCards.length === 2)
        this._match(card);
    },
    _match(card){
      if(this.flippedCards[0].name === this.flippedCards[1].name){
        setTimeout(() => {
          this.flippedCards.forEach(card => card.isMatched = true);
          this.flippedCards = [];
          //All cards matched ?
          if(this.memoryCards.every(card => card.isMatched === true)){
            this.finish = true;
            var memoryMissionCompletedAudio = [
              "BNP_Samodzielniak_18_G.mp3",
              "BNP_Samodzielniak_18_C.mp3",
              "BNP_Samodzielniak_18_D.mp3",
              "BNP_Samodzielniak_18_F.mp3",
              "BNP_Samodzielniak_18_B.mp3",
              "BNP_Samodzielniak_18_E.mp3",
              "BNP_Samodzielniak_18_A.mp3",
            ];
            var missionCompleted = memoryMissionCompletedAudio[Math.floor(Math.random() * memoryMissionCompletedAudio.length)];
            let audioMissionCompleted = new Howl({
              src: [require('@/assets/audio/memory/ogolne/misja_zaliczona/'+missionCompleted+'')]
            });
            audioMissionCompleted.play();

            this.audioPlayer({
              'url': [
                '/famfary/famfary.mp3'
              ],
            })

            this.showGameAccess = true;
            setTimeout(function(scope) {
              scope.showGameAccess = false;
              scope.showGameMap = true;
            }, 3500, this);
          }
        }, 400);

        var cardMatchSucess = [
          "BNP_Samodzielniak_16_D_1.mp3",
          "BNP_Samodzielniak_16_I_1.mp3",
          "BNP_Samodzielniak_17_C_2.mp3",
          "BNP_Samodzielniak_17_M_2.mp3",
          "BNP_Samodzielniak_17_D_2.mp3",
          "BNP_Samodzielniak_17_A_1.mp3",
          "BNP_Samodzielniak_16_F_1.mp3",
          "BNP_Samodzielniak_16_J_1.mp3",
          "BNP_Samodzielniak_17_H_2.mp3",
          "BNP_Samodzielniak_17_C_1.mp3",
          "BNP_Samodzielniak_17_B_2.mp3",
          "BNP_Samodzielniak_17_A_2.mp3",
          "BNP_Samodzielniak_17_J_2.mp3",
          "BNP_Samodzielniak_17_F_2.mp3",
          "BNP_Samodzielniak_16_H_1.mp3",
          "BNP_Samodzielniak_17_M_1.mp3",
          "BNP_Samodzielniak_17_K_1.mp3",
          "BNP_Samodzielniak_17_I_2.mp3",
          "BNP_Samodzielniak_17_B_1.mp3",
          "BNP_Samodzielniak_17_E_2.mp3",
          "BNP_Samodzielniak_16_G_1.mp3",
          "BNP_Samodzielniak_16_E_1.mp3",
          "BNP_Samodzielniak_17_K_2.mp3",
          "BNP_Samodzielniak_17_G_2.mp3"
        ];
        var randcardMatchSucess = cardMatchSucess[Math.floor(Math.random() * cardMatchSucess.length)];
        let audioCardSucess = new Howl({
          src: [require('@/assets/audio/memory/card/sucess/'+randcardMatchSucess+'')]
        });
        audioCardSucess.play();
      }
      else{
        setTimeout(() => {
          this.flippedCards.forEach((card) => {card.isFlipped = false});
          this.flippedCards = [];
          var cardMatchError = [
            "BNP_Samodzielniak_17_L_1.mp3",
            "BNP_Samodzielniak_17_L_2.mp3",
          ];
          var randcardMatchError = cardMatchError[Math.floor(Math.random() * cardMatchError.length)];
          let audioCardError = new Howl({
            src: [require('@/assets/audio/memory/card/error/'+randcardMatchError+'')]
          });
          audioCardError.play();

        }, 800);
      }
    },
    showGameAccess(){
      setTimeout(function(scope) {
        scope.showGameAccess = false;
        scope.showGameMap = true;
      }, 3500, this);
    },

    resetGame(payload){
      this.SET_ACTIVE_VIEW(payload);
      this.gameOver = false;
      this.finish = false
      this.cards.forEach((card) => {card.isFlipped = false});
      this.flippedCards = [];
      if (this.setupGame.gameType == 1){
        this.gamenameGTM = "Pieniądze od podszewki"
      }else if(this.setupGame.gameType == 2){
        this.gamenameGTM = "Misja bezpieczeństwo"
      }else if(this.setupGame.gameType == 3){
        this.gamenameGTM = "Zarządzam budżetem"
      }
      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - SPROBÓJ JESZCZE RAZ",
        label: this.gamenameGTM+": Przegrana",  //  gameType
      })
    },

  },
  mounted() {
    this.missionName = this.memoryGame.missionName;

  }
}
</script>

